import React, {useEffect, useState} from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import {useLang} from "../helpers/language";
import parse from "html-react-parser";

import AboutBlock from "../components/about-block/AboutBlock";
import Dot from "../components/icons/Dot";
import useScroll from "../assets/hooks/useScroll";
import {primaryColor} from "../assets/js/helpers";
import "../assets/css/pages/about-us.scss";
import {Dictionary} from "../assets/js/contexts";

const AboutUs = ({dictionary}) => {
    const scroll = useScroll();
    const {lang} = useLang();
    const [isBusy, setBusy] = useState(true);
    const [aboutUs, setAboutUs] = useState([]);
    const [aboutUsIndependent, setAboutUsIndependent] = useState([]);
    const [aboutUsCraft, setAboutUsCraft] = useState([]);
    const [aboutUsSmall, setAboutUsSmall] = useState([]);

    useEffect(() =>
    {
        window.scrollTo(0, 0);
        (async () => {
            let rowAboutUs = await API.get(config.api.aboutus);
            setAboutUs(rowAboutUs);

            let rowAboutUsCraft = await API.get(config.api.aboutusCraft);
            setAboutUsCraft(rowAboutUsCraft);

            let rowAboutUsIndependent = await API.get(config.api.aboutusIndependent);
            setAboutUsIndependent(rowAboutUsIndependent);

            let rowAboutUsSmall = await API.get(config.api.aboutusSmall);
            setAboutUsSmall(rowAboutUsSmall);

            setBusy(false);
        })();
    }, [isBusy]);
    if (!isBusy) 
        return (
            <Dictionary.Provider value={dictionary}>
                <div id="about-us">
                    <div className="header">
                        <div className="container animate"
                            data-expand={
                                scroll > 20
                            }/>
                        <div className="container">
                            <div className="row">
                                <div className="col-12 content bordered">
                                    <h1> {
                                        aboutUs ? aboutUs[0]?.title ? aboutUs[0]?.title[lang] ? aboutUs[0]?.title[lang] : "" : "" : ""
                                    } </h1>
                                    {
                                    parse(aboutUs ? aboutUs[0]?.desc ? aboutUs[0]?.desc[lang] ? aboutUs[0]?.desc[lang] : "" : "" : "")
                                }
                                    <div className="d-flex justify-content-center align-items-center"
                                        style={
                                            {marginTop: 54}
                                    }>
                                        <em>Craft</em>
                                        <Dot fill={primaryColor}
                                            size={0.5}/>
                                        <em>Independent</em>
                                        <Dot fill={primaryColor}
                                            size={0.5}/>
                                        <em>Small</em>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="wrapper white"
                        style={
                            {paddingBottom: 126}
                    }>
                        <div className="container">
                            <div className="row">
                                <div className="col-12 content">
                                    <div className="section">
                                        <Dot fill="black"/>
                                        <img src="/static/images/craft.svg" alt=""/>
                                    </div>
                                    {
                                    parse(aboutUsCraft ? aboutUsCraft[0]?.desc[lang] ? aboutUsCraft[0]?.desc[lang] : "" : '')
                                } </div>
                            </div>
                        </div>
                    </div>

                    <div className="wrapper black"
                        style={
                            {
                                paddingBottom: 143,
                                paddingTop: 138
                            }
                    }>
                        <div className="container">
                            <div className="row">
                                <div className="col-12 content">
                                    <div className="section">
                                        <Dot fill="white"/>
                                        <img src="/static/images/independent.svg" alt=""/>
                                    </div>
                                    {
                                    parse(aboutUsIndependent ? aboutUsIndependent[0]?.desc[lang] ? aboutUsIndependent[0]?.desc[lang] : '' : "")
                                } </div>
                            </div>
                        </div>
                    </div>

                    <div className="wrapper white"
                        style={
                            {
                                paddingBottom: 83,
                                paddingTop: 114
                            }
                    }>
                        <div className="container">
                            <div className="row">
                                <div className="col-12 content">
                                    <div className="section">
                                        <Dot fill="black"/>
                                        <img src="/static/images/small.svg" alt=""/>
                                    </div>
                                    {
                                    parse(aboutUsSmall ? aboutUsSmall[0]?.desc[lang] ? aboutUsSmall[0]?.desc[lang] : '' : "")
                                } </div>
                            </div>
                        </div>
                    </div>
                    <AboutBlock title={
                            config.aboutUsBlock.aboutUs.title[lang]
                        }
                        subTitle={''}
                        content={''}
                        buttonText={
                            config.aboutUsBlock.aboutUs.button[lang]
                        }
                        as={'/brewery'}
                        href={'/brewery'}/>
                </div>
            </Dictionary.Provider>
        );
     else 
        return <Loading type="Oval" color="#FFBE03" className="dms-loader"/>


    


};

export default AboutUs;
